export const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE';
